export interface RepoInterface {
  invalidateAll(): void;
}

export class BaseRepository {
  private registeredRepos: RepoInterface[] = [];

  /** Register a new repository for global actions. */
  addRepo(repo: RepoInterface) {
    this.registeredRepos.push(repo);
  }
  /** Unregister a previously registered repository. */
  removeRepo(repo: RepoInterface) {
    const index = this.registeredRepos.indexOf(repo);
    if (index > -1) this.registeredRepos.splice(index, 1);
  }

  // assigned by stores: required for circumventing cyclic module import issues

  /** Get the current user id. */
  getUserId(): string | undefined {
    return undefined;
  }

  /** Get the current tenant id. */
  getTenantId(): string | undefined {
    return undefined;
  }

  /** Clear all cache from all repositories. */
  clearAllCache(): void {
    for (const repo of this.registeredRepos) {
      repo.invalidateAll();
    }
  }

  /** Initialize the data with globally common fields. */
  init<T>(data: T) {
    const now = new Date();
    const userId = this.getUserId() || "UNKNOWN";

    return {
      id: undefined! as string,
      _source: "server" as "client" | "server",
      _schemaVersion: 1,
      _deleted: false,
      _version: 1,
      updatedAt: now,
      updatedBy: userId,
      createdAt: now,
      createdBy: userId,
      ...data,
    };
  }
}

export const baseRepo = new BaseRepository();
